import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { IReviewerRecommendation } from '@publishing-engine/domain/models';
import RinggoldBadge from 'src/components/RinggoldBadge';
import { Table } from '@morressier/alembic';

type IProps = { value: IReviewerRecommendation[] };

export const ReviewersDisplay: React.FC<IProps> = ({ value }) => {
  return (
    <>
      <Flex flexDirection="column" gap={4}>
        <Table>
          <Table.HeaderRow display="flex" alignItems="center">
            <Table.HeaderCell flex={0.4} paddingX={2}>
              S.No.
            </Table.HeaderCell>
            <Table.HeaderCell paddingX={2} flex={1}>
              Reviewer
            </Table.HeaderCell>
            <Table.HeaderCell paddingX={2} flex={1}>
              Affiliation
            </Table.HeaderCell>
            <Table.HeaderCell paddingX={2} flex={1}>
              Reason
            </Table.HeaderCell>
          </Table.HeaderRow>

          <Table.Body>
            {value.map((reviewer, index) => (
              <Table.Row
                alignItems="start"
                _last={{ borderBottom: 'none' }}
                key={index}
                data-cy="grant-row"
              >
                <Table.RowCell paddingX={2} flex={0.4}>
                  {index + 1}
                </Table.RowCell>
                <Table.RowCell
                  flex={1}
                  gap={2}
                  paddingX={2}
                  display="flex"
                  flexDirection="column"
                >
                  <Text textStyle="headingLine">{`${reviewer?.firstName} ${reviewer?.lastName}`}</Text>
                  <Text textStyle="textContext">{reviewer?.email}</Text>
                </Table.RowCell>

                <Table.RowCell
                  paddingX={2}
                  flex={1}
                  display="flex"
                  flexDirection="column"
                >
                  <Flex
                    flex={1}
                    gap={2}
                    display="flex"
                    flexDirection="row"
                    alignItems="flex-start"
                  >
                    {reviewer.ringgoldId && <RinggoldBadge />}
                    <Text textStyle="textBody">
                      {`${reviewer?.affiliation}, ${reviewer?.country}`}
                    </Text>
                  </Flex>
                </Table.RowCell>

                <Table.RowCell
                  flex={1}
                  paddingX={2}
                  gap={2}
                  display="flex"
                  alignItems="flex-start"
                  flexWrap="wrap"
                >
                  <Text textStyle="textBody">{reviewer?.reason}</Text>
                </Table.RowCell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Flex>
    </>
  );
};
